import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "lds-ring",
    style: _normalizeStyle({
      width: `${_ctx.width}px`,
      height: `${_ctx.width}px`
    })
  }, null, 4))
}